import { useEffect, useState } from "react";
import { useInvoiceStore } from "../../stores/invoice";
import { usePaymentStore } from "../../stores/payment";
import { showToastError } from "../../services/toast";
import { getInvoicesByCustomer } from "../../api/customerFile";
import { parseAmountInput, roundUpAmount } from "../../services/function";

const TableInvoices = () => {
  const { invoices, setInvoices } = useInvoiceStore();
  const {
    formData,
    idsInvoicesSelected,
    setIdsInvoicesSelected,
    viewOrUpdate,
    setInitialised,
    setBalance,
    balance,
    setTrueAmount,
  } = usePaymentStore();

  const [bloc, setBloc] = useState(false);

  // Chargement initial des factures
  useEffect(() => {
    if(formData.idCustomerFile ) {
      getInvoicesByCustomer(formData.idCustomerFile)
        .then((res) => {
          let formattedData = [];
          if(idsInvoicesSelected.length > 0 ) {
            formattedData = res.data.map((invoice: any) => ({
              id: invoice.id,
              balance: invoice.balance,
              totalAmount: invoice.totalAmount,
              issueDate: invoice.issueDate,
              invoiceNumber: invoice.invoiceNumber,
              amountApplied: invoice.amountApplied ?? 0,
              MAEFA: idsInvoicesSelected.find((inv: any) => inv.id === invoice.id)?.MAEFA ?? 0, 
              SAF: idsInvoicesSelected.find((inv: any) => inv.id === invoice.id)?.SAF ?? invoice.balance ?? 0
            }));
          } else {
            formattedData = res.data.map((invoice: any) => ({
              id: invoice.id,
              balance: invoice.balance,
              totalAmount: invoice.totalAmount,
              issueDate: invoice.issueDate,
              invoiceNumber: invoice.invoiceNumber,
              amountApplied: invoice.amountApplied ?? 0,
              MAEFA: 0, 
              SAF: invoice.balance ?? 0
            }));
          }

          const filteredData = formattedData.filter((invoice: any) => 
            invoice.balance !== 0 || idsInvoicesSelected.some((selected: any) => selected.id === invoice.id)
          );

          setInvoices(filteredData);  
        })
        .catch((err) => {
          showToastError(err.response.data.message)
        });
    }
  }, [formData.idCustomerFile, formData.invoices, viewOrUpdate, formData.amount]);

  useEffect(() => {
    if (viewOrUpdate !== "update") {
      const n = parseAmountInput(formData.amount);
      setBalance(Number.isFinite(n) ? n : 0);
    }
  }, [formData.amount]);

  useEffect(() => {
    if(balance === 0) {
      setBloc(true);
    } else {
      setBloc(false);
    }
  }, [balance]);

  // Gestion de la sélection/désélection
  const handleSelectedInvoices = (
    e: React.ChangeEvent<HTMLInputElement>,
    invoice: any
  ) => {
    setInitialised(false);
    // EN CHECKBOX SELECTIONNEE
    const formInvoice = invoices.find((inv: any) => inv.id === invoice.id);
    if(!formData.amount) {
      showToastError("Veuillez entrer un montant d'encaissement");
      return true;
    }

    if (e.target.checked) {
        if(balance >= formInvoice?.SAF) {
          setIdsInvoicesSelected([
            ...idsInvoicesSelected,
            { id: invoice.id, balance: invoice?.balance, totalAmount: invoice.totalAmount, invoiceNumber: invoice.invoiceNumber, amountApplied: formInvoice?.MAEFA, MAEFA: formInvoice?.SAF, SAF: 0},
          ]);
          setInvoices(invoices.map((inv: any) => inv.id === invoice.id ? { ...inv, balance: invoice.balance, totalAmount: invoice.totalAmount, invoiceNumber: invoice.invoiceNumber, amountApplied: formInvoice?.MAEFA, MAEFA: formInvoice?.SAF, SAF: 0} : inv));
          if(balance - invoice?.SAF < 0) {
            // Pour declancher la popup de difference
            setTrueAmount(roundUpAmount(balance - invoice?.SAF));
            setBalance(0);
          } else {
            // Pour declancher la popup de difference
            setTrueAmount(roundUpAmount(balance - invoice?.SAF));
            setBalance(balance - invoice?.SAF);
          }
        } else {
          setIdsInvoicesSelected([
            ...idsInvoicesSelected,
            { id: invoice.id, balance: invoice?.balance, totalAmount: invoice.totalAmount, invoiceNumber: invoice.invoiceNumber, amountApplied: invoice.amountApplied, MAEFA: Number(balance), SAF: invoice?.SAF - balance},
          ]);
          setInvoices(invoices.map((inv: any) => inv.id === invoice.id ? { ...inv, balance: invoice?.balance, totalAmount: invoice.totalAmount, invoiceNumber: invoice.invoiceNumber, amountApplied: invoice?.MAEFA, MAEFA: Number(balance), SAF: invoice?.SAF - balance} : inv));
          if(balance - invoice?.SAF < 0) {
            // Pour declancher la popup de difference
            setTrueAmount(roundUpAmount(balance - invoice?.SAF));
            setBalance(0);
          } else {
            // Pour declancher la popup de difference
            setTrueAmount(roundUpAmount(balance - invoice?.SAF));
            setBalance(balance - invoice?.SAF);
          }
        }
    } else { 
      const MAEFABEFORE = invoice?.MAEFA;
      setInvoices(invoices.map((inv: any) => inv.id === invoice.id ? { ...inv, balance: invoice?.balance, totalAmount: invoice.totalAmount, invoiceNumber: invoice.invoiceNumber, amountApplied: invoice.amountApplied, MAEFA: 0, SAF: invoice?.SAF + MAEFABEFORE} : inv));
      setIdsInvoicesSelected(idsInvoicesSelected.filter((inv: any) => inv.id !== invoice.id));
      setBalance(balance + invoice?.MAEFA);
      // Pour declancher la popup de difference
      setTrueAmount(roundUpAmount(balance + invoice?.MAEFA));
    }
  };

  return (
    <div className="w-full h-5/6 max-h-5/6 flex flex-col items-center">
      {formData.idCustomerFile ? (
        <div className="min-w-full bg-white rounded-xl shadow-lg border border-gray-200 h-full flex flex-col overflow-hidden w-11/12 my-5">
          <div className="overflow-auto flex-1">
            <table className="w-full">
              <thead className="sticky top-0 z-10">
                <tr className="bg-thead text-black w-full">
                  <th className="px-6 py-4 text-left font-semibold text-sm uppercase tracking-wider w-[5%]"></th>
                  <th className="px-6 py-4 text-left font-semibold text-sm uppercase tracking-wider w-[20%]">N° Facture</th>
                  <th className="px-6 py-4 text-left font-semibold text-sm uppercase tracking-wider w-[20%]">Date</th>
                  <th className="px-6 py-4 text-left font-semibold text-sm uppercase tracking-wider w-[20%]">Montant TTC</th>
                  <th className="px-6 py-4 text-left font-semibold text-sm uppercase tracking-wider w-[15%]">Solde</th>
                  <th className="px-6 py-4 text-left font-semibold text-sm uppercase tracking-wider w-[20%]">Nouveau solde</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {invoices.length > 0 ? (
                  invoices.map((invoice, index) => (
                    <tr
                      key={index}
                      className="group cursor-pointer transition-all duration-200 hover:bg-linear-to-r hover:from-blue-50 hover:to-blue-50 w-full"
                    >
                      <td className="px-6 py-4 align-middle w-[5%]">
                        <input
                          type="checkbox"
                          disabled={bloc && !idsInvoicesSelected.some((selected: any) => selected.id === invoice.id)}
                          checked={
                            Array.isArray(idsInvoicesSelected) &&
                            (typeof idsInvoicesSelected[0] === "object"
                              ? idsInvoicesSelected.some(
                                  (selected) => selected.id === invoice.id
                                )
                              : idsInvoicesSelected.includes(invoice.id))
                          }
                          onChange={(e) => handleSelectedInvoices(e, invoice)}
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
                        />
                      </td>
                      <td className="px-6 py-4 align-middle text-gray-700 font-medium w-[20%]">
                        {invoice.invoiceNumber}
                      </td>
                      <td className="px-6 py-4 align-middle text-gray-700 w-[20%]">
                        {invoice.issueDate}
                      </td>
                      <td className="px-6 py-4 align-middle text-gray-700 w-[20%]">
                        <span className="font-semibold text-gray-800">
                          {invoice.totalAmount}
                        </span>
                      </td>
                      <td className="px-6 py-4 align-middle text-gray-700 w-[15%]">
                        <span className="font-semibold text-gray-800">
                          {invoice?.balance?.toFixed(2)}€
                        </span>
                      </td>
                      <td className="px-6 py-4 align-middle  text-gray-700 w-[20%]">
                        <span className={`font-semibold text-gray-400`}>
                          {invoice?.SAF?.toFixed(2) }€
                        </span>
                      </td>
                    </tr>
                  ))
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center text-gray-400 h-full">
          <svg className="w-16 h-16 mb-4 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
          <p className="text-lg font-medium text-gray-600">Veuillez sélectionner un client</p>
          <p className="text-sm text-gray-500 mt-1">Les factures du client sélectionné apparaîtront ici</p>
        </div>
      )}
    </div>
  );
};

export default TableInvoices;
